import React, { useState } from "react";

import { Building2, AlertCircle, Loader2, Check } from "lucide-react";

import { authFetch } from '../../../../../HttpClient';

import { dialog } from "../../../../../components/ui/Dialog";
const ModifAutresMission = ({ item, onClose, fetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    dbe: item.dbe,
    bailCommercial: item.bailCommercial,
    contratParticulier: item.contratParticulier,
    dueDate: item.dueDate ? item.dueDate.split("T")[0] : "",
    priority: item.priority || "classique",
    status: item.status || "En attente",
    coefficient: item.coefficient || "",
    commentaire: item.commentaire || "",
  });

  console.log("Form Data:", formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    try {
      const droitPayload = {
        description: "autresMission",
        dbe: formData.dbe,
        bailCommercial: formData.bailCommercial,
        contratParticulier: formData.contratParticulier,
        commentaire: formData.commentaire,
        //
        dueDate: formData.dueDate,
        priority: formData.priority,
        status: formData.status,
        coefficient: formData.coefficient,
      };
      const res = await authFetch(`https://backend-myalfa.vercel.app/api/autresMission/${item.id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(droitPayload),
        }
      );

      if (!res.ok) throw new Error("Erreur lors de la modification");
    } catch (error) {
      console.error(error);
      dialog.alert("Erreur lors de la modification");
    } finally {
      onClose();
    }
    fetchData();
  };

  return (
    <div className="w-full px-8">
      <div className="flex items-center gap-3 pb-3 border-b mt-5">
        <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center">
          <Building2 className="w-4 h-4 text-emerald-600" />
        </div>
        <h3
          className="text-lg font-semibold text-slate-900 leading-none"
          style={{ margin: 0 }}
        >
          Autre Mission
        </h3>
      </div>
      <form onSubmit={handleSubmit}>
        <br />
        <div className="bg-gradient-to-br from-[#9B1B5D]/5 via-white to-transparent rounded-xl p-5 border-2 border-[#9B1B5D]/20">
          {/* Titre */}
          <h4 className="text-sm font-bold text-[#9B1B5D] mb-4 flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            Informations essentielles
          </h4>
          <div className="space-y-4">
            <div
              style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}
            >
              <label>DBE :</label>
              <label>
                <input
                  type="radio"
                  name="dbe"
                  value="true"
                  checked={formData.dbe === true}
                  onChange={handleChange}
                />{" "}
                Oui
              </label>
              <label>
                <input
                  type="radio"
                  name="dbe"
                  value="false"
                  checked={formData.dbe === false}
                  onChange={handleChange}
                />{" "}
                Non
              </label>
            </div>

            <div
              style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}
            >
              <label>Bail Commercial :</label>
              <label>
                <input
                  type="radio"
                  name="bailCommercial"
                  value="true"
                  checked={formData.bailCommercial === true}
                  onChange={handleChange}
                />{" "}
                Oui
              </label>
              <label>
                <input
                  type="radio"
                  name="bailCommercial"
                  value="false"
                  checked={formData.bailCommercial === false}
                  onChange={handleChange}
                />{" "}
                Non
              </label>
            </div>

            <div
              style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}
            >
              <label>Contrat Particulier :</label>
              <label>
                <input
                  type="radio"
                  name="contratParticulier"
                  value="true"
                  checked={formData.contratParticulier === true}
                  onChange={handleChange}
                />{" "}
                Oui
              </label>
              <label>
                <input
                  type="radio"
                  name="contratParticulier"
                  value="false"
                  checked={formData.contratParticulier === false}
                  onChange={handleChange}
                />{" "}
                Non
              </label>
            </div>
          </div>
        </div>

        <div>
          <label className="text-sm font-medium text-slate-700 mt-4 block">
            Commentaire :
          </label>
          <textarea
            name="commentaire"
            rows={4}
            value={formData.commentaire}
            onChange={handleChange}
            placeholder="Précisions..."
            className="w-full rounded-md border-2 border-slate-300 px-3 py-2 text-sm bg-white outline-none focus:border-emerald-400 transition-all"
          />
        </div>
        <hr style={{ margin: "25px 0" }} />
        <div className="grid grid-cols-4 gap-3 mt-5">
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Echéance{" "}
            </label>
            <input
              name="dueDate"
              type="date"
              value={formData.dueDate}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.dueDate
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            />
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Priorité
            </label>
            <select
              name="priority"
              value={formData.priority}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.priority
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            >
              <option value="classique">Classique</option>
              <option value="élevé">Élevé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Status
            </label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.status
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            >
              <option value="En attente">En attente</option>
              <option value="En attente informations / documents">
                En attente informations / documents
              </option>
              <option value="En attente interne">En attente interne</option>
              <option value="Dépôt de capital en cours">
                Dépôt de capital en cours
              </option>
              <option value="Rédaction">Rédaction</option>
              <option value="Supervision">Supervision</option>
              <option value="Signature">Signature</option>
              <option value="Signature en cours">Signature en cours</option>
              <option value="Formalité">Formalité</option>
              <option value="Formalité déposée">Formalité déposée</option>
              <option value="Formalité à régulariser">
                Formalité à régulariser
              </option>
              <option value="Formalité rejetée">Formalité rejetée</option>
              <option value="Bloqué">Bloqué</option>
              <option value="Abandonné">Abandonné</option>
              <option value="Terminé">Terminé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Coefficient
            </label>
            <input
              name="coefficient"
              type="text"
              value={formData.coefficient}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.coefficient
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            />
          </div>
        </div>

        <br />
        <div className="sticky bottom-0 bg-white border-t mt-4 px-8 py-4 flex items-center justify-between">
          <button
            type="button"
            variant="outline"
            onClick={onClose}
            className={`
              px-8
              h-11
              border-2
              border-slate-300
              text-slate-700
              rounded-md
              font-medium
              hover:bg-slate-100
              transition-colors
            `}
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`
w-1/2
h-11
${
  isSubmitting
    ? "bg-gray-400 cursor-not-allowed"
    : "bg-[#9B1B5D] hover:bg-[#7A1548]"
}
text-white
text-base
font-medium
rounded-md
shadow-lg shadow-[#9B1B5D]/20
transition-colors
flex items-center justify-center
gap-2
`}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                Modifiaction en cours...
              </>
            ) : (
              <>
                <Check className="w-5 h-5 mr-2" />
                Modifier la mission
              </>
            )}
          </button>
        </div>
        <br />
      </form>
    </div>
  );
};

export default ModifAutresMission;
